var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 18,
    fill: "#FFD15C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.265 42.043c-.023 0-.044 0-.069-.002a4.94 4.94 0 01-1.606-.355 4.958 4.958 0 01-2.726-6.453l12.811-22.445A4.924 4.924 0 0126.6 10.87a4.958 4.958 0 016.73 1.934L46.06 35.078c.283.666.404 1.209.434 1.762a4.922 4.922 0 01-1.27 3.573 4.914 4.914 0 01-3.422 1.628l-25.41.002h-.126z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.468 22.536c0-.843.688-1.53 1.531-1.53.844 0 1.531.687 1.531 1.53v4.95c0 .845-.688 1.53-1.531 1.53a1.533 1.533 0 01-1.531-1.53v-4.95zm0 10.936c0-.848.688-1.54 1.531-1.54.844 0 1.531.683 1.531 1.521 0 .863-.688 1.55-1.531 1.55a1.534 1.534 0 01-1.531-1.53z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.1f27152f62e45776030024c353b33792.svg";
export { ForwardRef as ReactComponent };